export enum FileUploaders {
  images = 'imagesService',
  productsSheets = 'productsSheetService',
}
